import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {BackendListModel} from "../../../../models/common/list.model";
import {IInsurance} from "../../../../models/common/insurance";
import {ApiRoutes} from "../../../../services/apiroutes";
import {DomainCode} from "../../../../models/common/model";
import {TermsAndConditionsModel} from "../../../../models/common/terms-and-conditions.model";
import {DocumentModel} from "../../../../models/document";
import {RequestDetailModel} from "../../../../models/request-detail-model";
import {environment} from "../../../../../environments/environment";
import {EmptyRepoQuoteChargeMasterError, QuoteChargeMasterError, RequestQuotesChargesList} from "../base-quote.model";
import {QuillEditorComponent} from "ngx-quill";
import {DomainCodeApiService} from "../../../../services/domain_code/domain-code-api.service";
import {RequestApiService} from "../../../../services/domain_code/request-api.service";
import {AuthService} from "../../../../services/auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {WarningBoxComponent} from "../../../dialog-box/warning-box/warning-box.component";
import {
    DropoffScheduleError,
    EmptyRepoQuoteItemError,
    EmptyRepoQuoteItemModel,
    EmptyRepoQuoteModel,
    PickupScheduleError
} from "../lease-quote-table/lease-quote";
import {LeaseDocuments} from "../../../../models/lease-quote";
import {EmptyRepoQuoteTableService} from "./empty-repo-quote-table.service";
import {EmptyRepoAddChargesComponent} from "./empty-repo-add-charges/empty-repo-add-charges.component";
import {MatTableDataSource} from "@angular/material/table";
import {FailureBoxComponent} from "../../../dialog-box/failure-box/failure-box.component";

@Component({
    selector: 'logzy-empty-repo-quote-table',
    templateUrl: './empty-repo-quote-table.component.html',
    styleUrls: ['./empty-repo-quote-table.component.scss']
})
export class EmptyRepoQuoteTableComponent implements OnInit {

    @Input() negotiate: boolean = true;
    @Input() case: string = '';
    @Input() refreshQuote = new BehaviorSubject(null);
    @Input() oldQuoteList;
    quoteList: EmptyRepoQuoteItemModel[];
    @Output() edit: EventEmitter<any> = new EventEmitter();
    @Output() review: EventEmitter<any> = new EventEmitter();
    @Output() updateRequest: EventEmitter<any> = new EventEmitter();
    @Output() errorLog: EventEmitter<any> = new EventEmitter();

    isCustomer: boolean;
    Editing: boolean = true;
    disableSaveButton: boolean = false;
    currentDate = new Date();
    insuranceList: BackendListModel<IInsurance>;
    downloadUrl = ApiRoutes.LeadRequest;
    insuranceUrl = `${ApiRoutes.Insurance}insurance/?search=::search::`
    ralUrl = `${ApiRoutes.ContainerMaster}ral_master/?search=::search::`;
    containerSizeTypeUrl = `${ApiRoutes.ContainerMaster}container_size_type/?search=::search::`
    containerConditionLists = `${ApiRoutes.DomainCode}?group=ContainerCondition`
    location_url = `${ApiRoutes.Location}?location_type_name=port&search=::search::`;
    company_url = `${ApiRoutes.Company}company/`;
    charge_url = `${ApiRoutes.ChargeMaster}charge_master/`;
    requestId: string;
    type: string;
    rType: string;

    containerConditionList: BackendListModel<DomainCode>;
    termsConditionList: TermsAndConditionsModel[] = [];
    tncExpand: boolean = true;
    uploadDocExpand: boolean = false;
    remarkExpand: boolean = true;
    isQuotation: boolean = true;
    isEditable: boolean = false;
    reviewquote: boolean = false;
    errorObj: any = {};
    termsAndCondition: TermsAndConditionsModel;
    selectedTermsAndCondition: string = '';
    documentTypeList: LeaseDocuments[] = [];
    selectedDocument: LeaseDocuments = null;
    selectedDocumentType: string = "";
    uploadedDocuments: DocumentModel[] = [];
    showUpload: boolean = false;
    showRemarks: boolean = false;
    remarks: string = '';
    disableSave: boolean = false;
    loading: boolean = false;
    penaltyTypesOptions;
    empty_repo_quote_for_post = {};
    empty_repo_quote_for_review = {};
    quoteItemsPayload = [];
    quoteChargesPayload = [];

    @Input() requestDetails: RequestDetailModel;
    displayedColumns: string[] = ['original_filename', 'document_size', 'document_type', 'created_by'];
    @Output() editLR = new EventEmitter<any>();

    base_url = environment.baseApiUrl;
    dd_leaseOptions: any;
    dd_leaseUse: BackendListModel<DomainCode>;

    modules = {};
    @ViewChild('editor', {static: false}) editor: QuillEditorComponent;

    scheduleList: EmptyRepoQuoteModel;
    viewScheduleTable: boolean = false;
    quoteChargesList: any[] = [];
    consolidatedQuoteCharges: RequestQuotesChargesList[] = [];
    nonConsolidatedQuoteCharges: RequestQuotesChargesList[] = [];
    chargeMasterValidated: boolean = true;
    quoteChargeMasterValidated: boolean = true;
    chargeMasterPayload = [];
    chargesPayload = [];
    default_currency: any;
    @Input() emptyRepoRequestDetails: any | undefined;
    chargesDataSource;
    displayedColumnsCharges: string[] = [];
    currencyMaster_url = ApiRoutes.CurrencyMaster;
    currency_code: string = 'INR';
    charge = null;
    requirement = null;

    constructor(private domainService: DomainCodeApiService,
                public requestService: RequestApiService,
                private authService: AuthService,
                private snackBar: MatSnackBar,
                private route: ActivatedRoute,
                public router: Router,
                private dialog: MatDialog,
                private _snackBar: MatSnackBar,
                private cdRef: ChangeDetectorRef,
                public emptyRepoQuoteTableService: EmptyRepoQuoteTableService) {
        this.modules = {
            toolbar: false
        }
    }


    ngOnInit(): void {
        console.log("emptyRepoRequestDetails", this.emptyRepoRequestDetails);
        this.refreshComponent();
        this.route.queryParams.subscribe(params => {
            if ('id' in params || 'type' in params || 'rtype' in params) {
                this.requestId = params['id'];
                // this.type = params['type'];
                this.rType = params['rtype'];
            }
        });
        this.isCustomer = this.authService.isCustomer();
        this.getLeaseUse();
        if (!this.isCustomer) {
            this.getPenaltyTypes();
        }
        this.getContainerCondition();
        this.getDocumentTypeList();
        this.getRequestQuoteCharges();

        if (this.isCustomer) {
            this.displayedColumnsCharges = ['charge_name', 'requirement', 'rec_amount', 'rec_total', 'rec_remark', 'pay_amount', 'paid_to', 'pay_remark', 'pay_total'];
        } else {
            this.displayedColumnsCharges = ['charge_name', 'requirement', 'pay_amount', 'paid_to', 'pay_remark', 'pay_total'];
        }

        this.chargesDataSource = new MatTableDataSource<null>;

        // this.getRemarksList();
        this.refreshQuote.subscribe(item => {
            this.viewScheduleTable = false;
            console.log('refreshQuote item', item);
            if (item == null)
                return;
            if (item == 'review') {
                this.reviewQuote('review');
                return;
            }
            if (item == 'error') {
                this.emptyRepoQuoteTableService.baseQuote.quote_items = [];
                for (let i = 0; i < this.requestService.selectedRequest.requirement.length; i++) {
                    this.emptyRepoQuoteTableService.baseQuote.quote_items[i] = new EmptyRepoQuoteItemModel();
                    this.emptyRepoQuoteTableService.baseQuote.error.quote_items[i] = new EmptyRepoQuoteItemError();
                    this.emptyRepoQuoteTableService.baseQuote.quote_items[i].saveFirstPayload(this.requestService.selectedRequest.requirement[i]);
                    this.emptyRepoQuoteTableService.baseQuote.quote_items[i].pol_list = this.requestService.selectedRequest.pols;
                    this.emptyRepoQuoteTableService.baseQuote.quote_items[i].pod_list = this.requestService.selectedRequest.pods;
                    this.emptyRepoQuoteTableService.baseQuote.pickup_schedules = [];
                    this.emptyRepoQuoteTableService.baseQuote.dropoff_schedules = [];
                    this.scheduleList = null;
                    this.viewScheduleTable = true;
                    this.quoteList = this.emptyRepoQuoteTableService.baseQuote.quote_items;
                }
            } else {
                // this.baseQuote = new LeaseQuoteModel(item);
                console.log("this.emptyRepoQuoteTableService.baseQuote",this.emptyRepoQuoteTableService.baseQuote)
                this.emptyRepoQuoteTableService.baseQuote = new EmptyRepoQuoteModel(item);
                this.emptyRepoQuoteTableService.termsAndCondition = this.emptyRepoQuoteTableService.baseQuote.terms_and_condition_fk;
                this.emptyRepoQuoteTableService.selectedTermsAndCondition = this.emptyRepoQuoteTableService.baseQuote.terms_and_condition_text;
                for (let i = 0; i < item.quote_items.length; i++) {
                    this.emptyRepoQuoteTableService.baseQuote.quote_items[i] = new EmptyRepoQuoteItemModel(item.quote_items[i]);
                    this.emptyRepoQuoteTableService.baseQuote.error.quote_items[i] = new EmptyRepoQuoteItemError();
                }

                this.quoteList = this.emptyRepoQuoteTableService.baseQuote.quote_items;
                this.quoteList.map(quote => {
                    quote.ad_hoc_charges.map(charge => charge.error = new EmptyRepoQuoteChargeMasterError());
                });

                if (this.emptyRepoQuoteTableService.baseQuote.uploaded_documents.length != 0) {
                    this.showUpload = true;
                }

                if (this.emptyRepoQuoteTableService.baseQuote.pickup_schedules.length != 0) {
                    this.emptyRepoQuoteTableService.baseQuote.pickup_schedules.map(pickup => pickup.error = new PickupScheduleError());
                    this.emptyRepoQuoteTableService.baseQuote.dropoff_schedules.map(dropoff => dropoff.error = new DropoffScheduleError());
                }
                // console.log("this.quoteList check new", this.quoteList)

                if (this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.length != 0) {
                    this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.map(charges => charges.error = new QuoteChargeMasterError());
                }

                console.log('item ------------------>', item);
                this.scheduleList = item;
                this.viewScheduleTable = true;

            }
            if (this.emptyRepoRequestDetails.status.dev_name = 'received') {
                this.default_currency = this.emptyRepoRequestDetails.requestor.company?.default_currency;
                this.quoteList = this.emptyRepoQuoteTableService.baseQuote.quote_items;
            }
            this.getTermsAndConditionMasterList();
            this.cdRef.detectChanges();

            console.log(this.quoteList);
        });
    }

    refreshComponent() {
        this.emptyRepoQuoteTableService.baseQuote = new EmptyRepoQuoteModel();
        this.isCustomer = this.authService.isCustomer();
        this.getTermsAndConditionMasterList();
    }

    getContainerCondition() {
        this.domainService.getByGroup('ContainerCondition').subscribe({
            next: response => {
                this.containerConditionList = response;
            },
            error: error => {
                return error;
            }
        });
    }

    editQuote() {
        this.Editing = !this.Editing;
        this.edit.emit();
    }

    saveQuotation() {
        this.quoteChargeMasterValidated = true;
        this.disableSaveButton = true;
        this.empty_repo_quote_for_post = [];
        // this.chargeMasterValidated

        let invalidCount = 0;
        let invalidCurrency = 0;

        this.chargesDataSource.data.map((data: any) => {
            if ((data.pay_total != 0 || data.rec_total != 0) && data.paid_to == '') {
                invalidCount++;
            }

            if ((data.pay_currency == null || data.rec_currency == null)) {
                invalidCurrency++;
            }
        });

        if (invalidCount > 0) {
            this.openWarningDialog('Payable to cannot be empty if amount is entered', '', 'Ok');
            this.disableSaveButton = false;
            return;
        }

        if (invalidCurrency > 0) {
            this.openWarningDialog('Please enter valid currency', '', 'Ok');
            this.disableSaveButton = false;
            return;
        }

        this.getQuoteChargeMasterPayload();
        //
        // if (this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.length != 0) {
        //     for (let i = 0; i < this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.length; i++) {
        //         for (let k = i + 1; k < this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.length; k++) {
        //             if (this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges[i]?.quote_charge.id == this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges[k]?.quote_charge.id) {
        //                 this.openWarningDialog('Duplicate Request Quote Ad-hoc charge entries', '', 'Ok');
        //                 return;
        //             }
        //         }
        //     }
        // }
        //
        // if (!this.chargeMasterValidated) {
        //     this.disableSaveButton = false;
        //     this.openWarningDialog('Please select charge and enter all details', '', 'Ok');
        //     return;
        // }


        // console.log('After patching', this.quoteList);

        this.quoteList.map((quote: any) => {
            quote.charges.map((charge: any) => {
                charge.quote_charge = charge?.charge_name?.id;
                charge.amount = charge.amount == null ? 0 : charge.amount;
                charge.amount_currency = charge.amount_currency;
                charge.pay_amount = charge.pay_amount == null ? 0 : charge.pay_amount;
                charge.pay_currency = charge.pay_currency;
                charge.payable_to = charge.paid_to ? charge.paid_to.id : null;
                charge.pay_remarks = charge.pay_remarks;
                charge.rec_remarks = charge.rec_remarks;
            })
        });

        this.quoteItemsPayload = [];

        this.quoteList.map((quote: any) => {
            let charges: any[] = [];

            quote.charges.map((item: any) => {
                charges.push({
                    amount: item.amount,
                    amount_currency: item.amount_currency,
                    pay_amount: item.pay_amount,
                    pay_amount_currency: item.pay_currency,
                    pay_remarks: item.pay_remarks,
                    payable_to: item.paid_to ? item.paid_to.id : null,
                    quote_charge: item.charge_name?.id,
                    rec_remarks: item.rec_remarks,
                    requirement: item.requirement?.requirement
                })
            });

            this.quoteItemsPayload.push({
                requirement: quote.requirement,
                container_size_type: quote.container_size_type ? quote.container_size_type.id : null,
                container_condition: quote.container_condition ? quote.container_condition.id : null,
                pol_list: quote.pol_list ? quote.pol_list.map((item) => item.id) : [],
                pod_list: quote.pod_list ? quote.pod_list.map((item) => item.id) : [],
                quantity: quote.quantity,
                payee: this.requestDetails?.requestor?.role == 'customer' ? 'customer' : 'arcon',
                inland_haulage: quote.inland_haulage,
                ad_hoc_charges: charges
            })
        });

        // console.log(this.quoteList);
        this.empty_repo_quote_for_post = {
            quote_items: this.quoteItemsPayload,
            quote_valid_till: this.emptyRepoQuoteTableService.baseQuote.quote_valid_till,
            remarks: this.emptyRepoQuoteTableService.baseQuote.remarks,
            terms_and_condition_text: this.selectedTermsAndCondition,
            terms_and_condition_fk: this.termsAndCondition.id,
            // terms_and_condition_fk : this.emptyRepoQuoteTableService.baseQuote?.terms_and_condition_fk?.id,
            request: this.requestId,
            uploaded_documents: this.emptyRepoQuoteTableService.baseQuote.uploaded_documents ? this.emptyRepoQuoteTableService.baseQuote.uploaded_documents.map(item => item.id) : [],
            ad_hoc_charges: this.chargeMasterPayload,
            payee: this.requestDetails?.requestor?.role == 'customer' ? 'customer' : 'arcon',
            inland_haulage: this.quoteItemsPayload[0].inland_haulage
        }

        console.log("empty_repo_quote_for_post",this.empty_repo_quote_for_post);

        this.requestService.postQuotations(this.empty_repo_quote_for_post).subscribe({
            next: response => {
                this.snackBar.open('Quotations saved', 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                // console.log('postQuotations', response);
                this.disableSaveButton = false;
                this.emptyRepoQuoteTableService.confirmEmptyRepoBooking(this.empty_repo_quote_for_post);
                // window.location.reload();
                return response;
            },
            error: error => {
                console.log('error', error);
                // this.infoContentComponent.isEditable = true;
                // this.infoContentComponent.catchError(error);
                this.disableSaveButton = false;
                if (error.status >= 500) {
                    this.snackBar.open('Something went wrong!! Please try again after sometime.', 'Close', {
                        verticalPosition: 'top',
                        duration: 5000,
                    });
                    return error;
                } else if (error.status > 399 && error.status < 500) {
                    if ('requestor' in error.error) {
                        let label = 'Customer KYC Pending'
                        let desc = ''
                        error.error.requestor.forEach(item => {
                            desc += `• ${item}\n`
                        })
                        this.openDialogOnError(label, desc)
                    } else 
                    if ('sales_person' in error.error && 'billing_entity' in error.error) {
                        const message = `Please update the below details to proceed further:<br><br>• Sales Person<br>• Billing Entity`;
                        this.openWarningEditRequest(message, '', 'Ok');
                        } else if ('sales_person' in error.error) {
                            this.openWarningEditRequest('Enter the sales person name to proceed further.', '', 'Ok');
                        } else if ('billing_entity' in error.error) {
                            this.openWarningEditRequest('Enter the billing entity to proceed further.', '', 'Ok');
                        }
                    return error;
                }
                return this.catchError(error);
            }
        });
    }

    getQuoteChargeMasterPayload() {
        this.chargeMasterPayload = [];
        if (this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.length != 0) {
            this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.map((charge: any) => {
                charge.quote_charge = charge?.charge_name?.id;
                charge.amount = charge.amount == null ? 0 : charge.amount;
                charge.amount_currency = charge.amount_currency;
                charge.pay_amount = charge.pay_amount == null ? 0 : charge.pay_amount;
                charge.pay_currency = charge.pay_currency;
                charge.payable_to = charge.paid_to ? charge.paid_to.id : null
                charge.pay_remarks = charge.pay_remarks;
                charge.rec_remarks = charge.rec_remarks;
            });

            this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.map((item: any) => {
                this.chargeMasterPayload.push({
                    amount: item.amount,
                    amount_currency: item.amount_currency,
                    pay_amount: item.pay_amount,
                    pay_amount_currency: item.pay_currency,
                    pay_remarks: item.pay_remarks,
                    payable_to: item.paid_to ? item.paid_to.id : null,
                    quote_charge: item.charge_name?.id,
                    rec_remarks: item.rec_remarks,
                    requirement: null
                })
            });
        }
    }

    getLeaseUse() {
        this.domainService.getByGroup('ContainerPurpose').subscribe(response => {
            this.dd_leaseUse = response;
        })
    }

    reviewQuote(type: string) {
        if (this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.length != 0) {
            this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.map((charge: any) => {
                console.log(charge.quote_charge, charge.amount, charge.amount_currency);
                if (charge.quote_charge == null || charge.amount == null || charge.amount_currency == null) {
                    this.quoteChargeMasterValidated = false;
                } else {
                    this.quoteChargeMasterValidated = true;
                }
            })

            for (let i = 0; i < this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.length; i++) {
                for (let k = i + 1; k < this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.length; k++) {
                    if (this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges[i]?.quote_charge?.id == this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges[k]?.quote_charge?.id) {
                        this.openWarningDialog('Duplicate Request Quote Ad-hoc charge entries', '', 'Ok');
                        return;
                    }
                }
            }
        }

        if (!this.quoteChargeMasterValidated) {
            this.disableSaveButton = false;
            this.openWarningDialog('Please select charge and enter all details', '', 'Ok');
            return;
        }

        this.getReviewQuote();
        let skipReview = false;

        this.quoteItemsPayload.map(quoteItems => {
            if (quoteItems.charges.length != 0) {
                quoteItems.charges.map(charge => {
                    if (charge.quote_charge == null || charge.amount == null || charge.amount_currency == null) {
                        this.quoteChargeMasterValidated = false;
                    }
                });

                for (let i = 0; i < quoteItems.charges.length; i++) {
                    for (let k = i + 1; k < quoteItems.charges.length; k++) {
                        if (quoteItems.charges[i]?.quote_charge.id == quoteItems.charges[k]?.quoteItems_charge.id) {
                            this.openWarningDialog('Duplicate charge entries', '', 'Ok');
                            this.disableSaveButton = false;
                            skipReview = true;
                            return;
                        }
                    }
                }
            } else {
                this.quoteChargeMasterValidated = true;
            }
        });

        if (skipReview) return;

        if (!this.quoteChargeMasterValidated) {
            this.disableSaveButton = false;
            this.openWarningDialog('Please select charge and enter all details', '', 'Ok');
            return;
        }

        this.empty_repo_quote_for_review = {
            ad_hoc_charges: this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges,
            quote_items: this.quoteItemsPayload,
            quote_valid_till: this.emptyRepoQuoteTableService.baseQuote.quote_valid_till,
            remarks: this.emptyRepoQuoteTableService.baseQuote.remarks,
            terms_and_condition_text: this.selectedTermsAndCondition,
            terms_and_condition_fk: this.termsAndCondition.id,
            request: this.requestId,
            uploaded_documents: this.emptyRepoQuoteTableService.baseQuote.uploaded_documents
        }
        this.emptyRepoQuoteTableService.type = type;
        this.review.emit(this.empty_repo_quote_for_review);
    }

    getReviewQuote() {
        this.quoteItemsPayload = [];
        const adHocCharges = this.quoteList[0].charges;
        for (let i = 1; i < this.quoteList.length; i++) {
            const currentAdHocCharges = this.quoteList[i].charges;
            for (let j = 0; j < adHocCharges.length && j < currentAdHocCharges.length; j++) {
                currentAdHocCharges[j].quote_charge = adHocCharges[j].quote_charge;
            }
        }

        this.quoteList.map(quote => {
            this.quoteItemsPayload.push({
                charges: quote.charges,
                requirement: quote.requirement,
                container_size_type: quote.container_size_type,
                container_condition: quote.container_condition,
                pol_list: quote.pol_list ? quote.pol_list.map((item) => item) : [],
                pod_list: quote.pod_list ? quote.pod_list.map((item) => item) : [],
                quantity: quote.quantity,
            })
        });
    }

    catchError(error) {
        if (error.status >= 500) {
            this.snackBar.open('Something went wrong!! Please try again after sometime.', 'Close', {
                verticalPosition: 'top',
                duration: 5000,
            });
            return error;
        } else if (error.status > 399 && error.status < 500) {
            this.emptyRepoQuoteTableService.baseQuote.patchErrors(error.error);
            return error;
        }
    }

    editReview() {
        this.isEditable = true;
    }

    editRequest(data) {
        this.editLR.emit(data);
    }

    getPenaltyTypes() {
        this.requestService.getPenaltyTypes(this.requestId).subscribe(response => {
            this.penaltyTypesOptions = response;
        });
    }

    getTermsAndConditionMasterList() {
        this.requestService.getTermsAndConditionsListLease(this.requestService.selectedRequest).subscribe({
            next: response => {
                this.termsConditionList = response.results;
                console.log(this.termsConditionList,"this.termsConditionList")
                if (this.termsConditionList.length != 0) {
                    if (this.emptyRepoQuoteTableService.baseQuote.terms_and_condition_fk != null) {
                        this.termsAndCondition = {
                            id: this.termsConditionList.filter(item => item.id == this.emptyRepoQuoteTableService.baseQuote.terms_and_condition_fk.id),
                            name: this.termsConditionList.filter(item => item.id == this.emptyRepoQuoteTableService.baseQuote.terms_and_condition_fk.name)
                        };
                        this.selectedTermsAndCondition = this.emptyRepoQuoteTableService.baseQuote.terms_and_condition_text;
                    } else {
                        this.termsAndCondition = {
                            id: this.termsConditionList[0].id,
                            name: this.termsConditionList[0].name
                        };
                        this.selectedTermsAndCondition = this.termsConditionList[0].terms_condition;
                    }
                }
                return response;
            },
            error: error => {
                // console.log(error)
                return error;
            }
        })
    }

    showSelectedTermsAndCondition() {
        if (this.termsConditionList.length != 0) {
            this.termsConditionList.map(item => {
                if (item.id == this.termsAndCondition) {
                    this.termsAndCondition = {
                        id: item.id,
                        name: item.name
                    };
                    this.selectedTermsAndCondition = item.terms_condition;
                }
            })
        }
    }

    getDocumentTypeList() {
        this.requestService.getDocumentTypeList('lease_quote').subscribe(res => {
            this.documentTypeList = res.results;
        })
    }

    // getRemarksList() {
    //   this.requestService.getRemarksList(this.requestId).subscribe(res => {
    //     this.remarksList = res.results;
    //   })
    // }

    showDocumentUpload(event) {
        this.selectedDocument = event;
        if (this.selectedDocument != null) {
            this.selectedDocumentType = this.selectedDocument.dev_name;
            this.showUpload = true;
        } else {
            this.showUpload = false;
        }
    }

    addRemarks() {
        this.showRemarks = true;
    }

    // addNewRemarks() {
    //   if (this.remarks.length != 0) {
    //     this.requestService.postRequestRemarks(this.requestId, this.remarks, this.isInternal).subscribe(res => {
    //       this.remarksList = [];
    //       this.getRemarksList();
    //     })
    //     this.showRemarks = false;
    //   } else {
    //     window.alert('Please enter remarks')
    //   }
    // }

    cancelRemarksAddition() {
        this.remarks = '';
        this.showRemarks = false;
    }

    // getRemarks(event) {
    //   this.remarks = event.remarks;
    //   this.isInternal = event.is_internal;
    // }

    keysToTransform = [
        'lease_purpose',
    ];
    keysToTransform1 = [
        'terms_and_condition_fk'
    ]

    readableFileSize(size) {
        var units = ['B', 'KB', 'MB'];
        var i = 0;
        while (size >= 1024) {
            size /= 1024;
            ++i;
        }
        return size?.toFixed(2) + ' ' + units[i];
    }

    downloadQuote(quote) {
        window.open(`${this.downloadUrl}request_quotes/pdf/lease/${quote.id}/`, '_blank');
    }

    getRequestQuoteCharges() {
        this.requestService.getRequestQuoteCharges(this.rType).subscribe(res => {
            if (res.length != 0) {
                this.quoteChargesList = res;
                this.consolidatedQuoteCharges = res.filter(charge => charge.is_consolidated_charge == true);
                this.nonConsolidatedQuoteCharges = res.filter(charge => charge.is_consolidated_charge == false);
            }
            this.populateCharges();
        })
    }

    openWarningDialog(label: string, description, action1: string, action2?: string, action3: string = null) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {
                subTitle: label,
                parent: this,
                description: description,
                label1: action1,
                label2: action2,
                label3: action3
            }
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item) {
            }
        })
    }

    addEmptyRepoCharges() {
        const dialogData = {
            quoteList: this.quoteList,
            nonConsolidatedQuoteCharges: this.nonConsolidatedQuoteCharges
        };
        const dialogRef = this.dialog.open(EmptyRepoAddChargesComponent, {
            // width: '50%',
            disableClose: true,
            data: dialogData
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                console.log('addEmptyRepoCharges', result);
                if (this.chargesDataSource.data.length == 0) {
                    result.map(data => {
                        data.rec_total = data.basis != 'Job' ? (data.requirement?.quantity * data.rec_amount) : data.rec_amount;
                        data.pay_total = data.basis != 'Job' ? (data.requirement?.quantity * data.pay_amount) : data.pay_amount;
                    });
                    this.chargesDataSource = new MatTableDataSource(result);
                } else {
                    result.map(data => {
                        const newData = [...this.chargesDataSource.data];
                        data.rec_total = data.basis != 'Job' ? (data.requirement?.quantity * data.rec_amount) : data.rec_amount;
                        data.pay_total = data.basis != 'Job' ? (data.requirement?.quantity * data.pay_amount) : data.pay_amount;
                        newData.push(data);
                        this.chargesDataSource.data = newData;
                    })
                }
                console.log(this.chargesDataSource.data);
                this.patchChargesToRequirements();
            } else {

            }
        });
    }

    populateCharges() {
        let filteredChargesCon = this.consolidatedQuoteCharges.filter(item => item.auto_append_to_quotes == true);
        let filteredChargesNonCon = this.nonConsolidatedQuoteCharges.filter(item => item.auto_append_to_quotes == true);

        console.log('this.consolidatedQuoteCharges', filteredChargesCon);
        console.log('this.nonConsolidatedQuoteCharges', filteredChargesNonCon);

        let charges: any[] = [];

        filteredChargesCon.map(item => {
            charges.push({
                requirement: null,
                charge_name: item,
                basis: item.charge.uom.description,
                rec_remarks: '',
                pay_remarks: '',
                rec_amount: 0,
                rec_currency: 'INR',
                pay_amount: 0,
                pay_currency: 'INR',
                paid_to: '',
                rec_total: 0,
                pay_total: 0,
                custom: 0
            })
        });

        this.quoteList.map((requirement) => {
            filteredChargesNonCon.map(item => {
                charges.push({
                    requirement: item.charge.uom.dev_value != 'job' ? requirement : null,
                    charge_name: item,
                    basis: item.charge.uom.description,
                    rec_remarks: '',
                    pay_remarks: '',
                    rec_amount: 0,
                    rec_currency: 'INR',
                    pay_amount: 0,
                    pay_currency: 'INR',
                    paid_to: '',
                    rec_total: 0,
                    pay_total: 0,
                    custom: 0
                })
            })
        });

        // const filteredData = (() => {
        //     let hasNullRequirement = false;
        //
        //     return charges.filter(item => {
        //         if (item.requirement === null) {
        //             if (!hasNullRequirement) {
        //                 hasNullRequirement = true;
        //                 return true;
        //             }
        //             return false;
        //         }
        //         return true;
        //     });
        // })();

        charges.sort((a: any, b: any) => {
            if (a.requirement === null) return 1;
            if (b.requirement === null) return -1;
            return a.charge_name.id.localeCompare(b.charge_name.id);
        })

        console.log(charges);

        //
        // result.map(data => {
        //     data.rec_total = data.basis != 'Job' ? (data.requirement?.quantity * data.rec_amount) : data.rec_amount;
        //     data.pay_total = data.basis != 'Job' ? (data.requirement?.quantity * data.pay_amount) : data.pay_amount;
        // });
        this.chargesDataSource = new MatTableDataSource(charges);

        this.patchChargesToRequirements();
    }

    deleteCharge(idx, data) {
        const newData = [...this.chargesDataSource.data];
        newData.splice(idx, 1);
        this.chargesDataSource.data = newData;

        if (data.requirement == null) {
            const idx = this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.findIndex((charge: any) =>
                charge?.charge_name?.id === data?.charge_name?.id
            );
            if (idx > -1) {
                this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.splice(idx, 1);
            }
        } else {
            this.quoteList.map((quote) => {
                const idx = quote.charges.findIndex(charge =>
                    charge?.requirement?.requirement === data?.requirement?.requirement
                );
                if (idx > -1) {
                    quote.charges.splice(idx, 1);
                }
            })
        }
    }

    getTotalRec() {
        let count = 0;
        if (this.chargesDataSource.data.length != 0) {
            this.chargesDataSource.data.map((data: any) => {
                count += data.rec_total;
            })
            return count;
        } else
            return 0;
    }

    getTotalPay() {
        let count = 0;
        if (this.chargesDataSource.data.length != 0) {
            this.chargesDataSource.data.map((data: any) => {
                count += data.pay_total;
            })
            return count;
        } else
            return 0;
    }

    patchChargesToRequirements() {
        this.chargesDataSource.data.map((item: any) => {
            if (item.requirement === null)
                this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.push(item);
        });

        this.quoteList.map(quote => {
            quote.charges = [];
            this.chargesDataSource.data.map((data: any) => {
                if (quote.requirement == data.requirement?.requirement)
                    quote.charges.push(data);
            })
        })
    }

    calculateCharges(quote: any) {
        if (this.chargesDataSource.data.length != 0) {
            this.chargesDataSource.data.map((item: any) => {
                if (item.requirement?.requirement == quote.requirement) {
                    if (this.isCustomer) {
                        item.rec_total = Number(item.amount) * Number(quote.quantity);
                        item.pay_total = Number(item.pay_amount) * Number(quote.quantity);
                    } else {
                        item.pay_total = Number(item.pay_amount) * Number(quote.quantity);
                    }
                }
            })
        }
    }

    openDialogOnError(label, description) {
        const dialogRef = this.dialog.open(FailureBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {subTitle: label, description: description}
        });

        dialogRef.afterClosed().subscribe(item => {
            let baseUrl = window.location.href.replace(this.router.url, '');
            window.open(`${baseUrl}/master-data/customer-master?id=${this.requestService.selectedRequest.requestor?.company?.id}`, '_blank')
        })
    }

    openWarning(label: string, description, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {subTitle: label, parent: this, description: description, label1: action1, label2: action2}
        });
    }

    openWarningEditRequest(label: string, description, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {subTitle: label, parent: this, description: description, label1: action1, label2: action2}
        });

        dialogRef.afterClosed().subscribe(item => {
            this.errorLog.emit();
        })
    }

    setRecTotal(data: any) {
        data.rec_total = data.requirement != null ? (Number(data.rec_amount) * Number(data.requirement?.quantity)) : Number(data.rec_amount);
    }

    setPayTotal(data: any) {
        data.pay_total = data.requirement != null ? (Number(data.pay_amount) * Number(data.requirement?.quantity)) : Number(data.pay_amount);
    }

    updateChargesCurrency(data: any) {
        this.chargesDataSource.data.map((charge: any) => {
            if (charge.charge_name.id == data.charge_name.id) {
                charge.rec_currency = data.rec_currency;
                charge.pay_currency = data.pay_currency;
            }
        })
    }

    addNewCharge() {
        console.log(this.charge, this.chargesDataSource.data, this.requirement);
        let charges = [];
        if (this.charge != null) {
            if (this.charge.charge.uom.dev_value == 'job') {
                const filteredList: any[] = this.chargesDataSource.data.filter((item: any) => item.charge_name.id == this.charge.id);
                if (filteredList.length == 0) {
                    charges.push({
                        requirement: null,
                        charge_name: this.charge,
                        basis: this.charge.charge.uom.description,
                        rec_remarks: '',
                        pay_remarks: '',
                        rec_amount: 0,
                        rec_currency: 'INR',
                        pay_amount: 0,
                        pay_currency: 'INR',
                        paid_to: '',
                        rec_total: 0,
                        pay_total: 0,
                        custom: 1
                    })

                    this.chargesDataSource.data = [
                        ...this.chargesDataSource.data,
                        ...charges
                    ];

                    charges.map(charge => {
                        if (charge.requirement == null) {
                            this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.push(charge);
                        } else {
                            this.quoteList.map((requirement) => {
                                if (charge.requirement?.requirement == requirement.requirement)
                                    requirement.charges.push(charge);
                            })
                        }
                    })
                } else {
                    this.snackBar.open('Charge already added', 'Close', {
                        verticalPosition: 'top',
                        duration: 5000,
                    });
                }
            } else {
                if (this.requirement != null) {
                    const filteredList: any[] = this.chargesDataSource.data.filter((item: any) =>
                        item.charge_name.id == this.charge.id &&
                        item.requirement?.requirement == this.requirement?.requirement
                    )

                    if (filteredList.length == 0) {
                        charges.push({
                            requirement: this.charge.charge.uom.dev_value != 'job' ? this.requirement : null,
                            charge_name: this.charge,
                            basis: this.charge.charge.uom.description,
                            rec_remarks: '',
                            pay_remarks: '',
                            rec_amount: 0,
                            rec_currency: 'INR',
                            pay_amount: 0,
                            pay_currency: 'INR',
                            paid_to: '',
                            rec_total: 0,
                            pay_total: 0,
                            custom: 1
                        })

                        this.chargesDataSource.data = [
                            ...this.chargesDataSource.data,
                            ...charges
                        ];

                        charges.map(charge => {
                            if (charge.requirement == null) {
                                this.emptyRepoQuoteTableService.baseQuote.ad_hoc_charges.push(charge);
                            } else {
                                this.quoteList.map((requirement) => {
                                    if (charge.requirement?.requirement == requirement.requirement)
                                        requirement.charges.push(charge);
                                })
                            }
                        })
                    } else {
                        this.snackBar.open(`${this.charge?.charge?.charge_head} with requirement ${this.requirement?.container_size_type?.display} already added`, 'Close', {
                            verticalPosition: 'top',
                            duration: 5000,
                        });
                    }
                } else {
                    this.snackBar.open('Please select requirement', 'Close', {
                        verticalPosition: 'top',
                        duration: 5000,
                    });
                }
            }
        } else {
            this.snackBar.open('Please select charge', 'Close', {
                verticalPosition: 'top',
                duration: 5000,
            });
        }
    }
}
